import { ROUTER_PATH, ROUTER_TITLES } from '@/router/constants';
import FunctionPage from '@/pages/function/FunctionPage';
import MainFunctionPage from '@/pages/function/main/MainFunctionPage';
import ConvenienceFunctionPage from '@/pages/function/convenience/ConvenienceFunctionPage';

export const FunctionRouter = {
	element: <FunctionPage />,
	children: [
		{
			path: ROUTER_PATH.FUNCTION.MAIN,
			element: <MainFunctionPage />,
			title: ROUTER_TITLES.FUNCTION.MAIN
		},
		{
			index: true,
			path: ROUTER_PATH.FUNCTION.CONVENIENCE,
			element: <ConvenienceFunctionPage />,
			title: ROUTER_TITLES.FUNCTION.CONVENIENCE
		}
	]
};
